/**
 * Divider Widget for RUL Forms
 */

import { Divider } from 'antd';
import type { DividerWidget } from '@/api/types/rul.types';

interface DividerWidgetProps {
  widget: DividerWidget;
}

export const DividerWidgetComponent: React.FC<DividerWidgetProps> = ({
  widget,
}) => {
  if (!widget.visible) return null;

  return (
    <Divider
      type={widget.orientation === 'vertical' ? 'vertical' : 'horizontal'}
      className="rul-divider"
    />
  );
};
